import apiClient from "./apiClient";
import { isOfflineMode } from "@/helpers/offlineMode";
import type {
  QuoteRequestModel,
  QuoteDetailModel,
  LoanProposalRequest,
} from "@/models/underwriting";

/**
 * Creates a quote from a pricing result. Mirrors `createQuote` in the
 * workscreens plugin — POST application/create-quote returning the saved quote.
 */
const createQuote = async (payload: QuoteRequestModel): Promise<QuoteDetailModel> => {
  if (isOfflineMode()) {
    // Simulate a persisted quote with a generated id.
    return { ...payload, quoteId: Math.floor(Math.random() * 1_000_000) + 1 };
  }
  const { data } = await apiClient.post<QuoteDetailModel>("/application/create-quote", payload);
  return data;
};

/**
 * Proposes a saved quote to the lender. Mirrors `sendLoanProposal` in the
 * workscreens plugin — POST loan-proposal with `{ loanProposal, quoteDetail }`.
 */
const sendLoanProposal = async (
  loanProposal: LoanProposalRequest,
  quoteDetail: QuoteDetailModel
): Promise<void> => {
  if (isOfflineMode()) return;
  await apiClient.post("/loan-proposal", { loanProposal, quoteDetail });
};

export const proposalService = {
  createQuote,
  sendLoanProposal,
};
